/** /prep-lists: the card grid of day lists and weekly plans (handoff
 *  PrepLists.dc.html). Beta-locked: ComingSoon renders before any API call. */
import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon, useFeatureGate } from '@/components/ComingSoon';
import { IndexScreen } from '@/features/prep-lists/IndexScreen';

export const Route = createFileRoute('/_app/prep-lists/')({
  component: PrepListsIndexRoute,
});

function PrepListsIndexRoute() {
  if (useFeatureGate('prep')) return <ComingSoon feature="prep" />;
  return <IndexScreen />;
}
